<ng-container *ngIf="feeSchedule$ | async as feeSchedule">
  <strong>Fee Schedule: </strong>{{feeSchedule.name}}
</ng-container>
